// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clickable-text[data-v-6296fa14] {
  cursor: pointer !important;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/text-element/TextElement.vue","webpack://./TextElement.vue"],"names":[],"mappings":"AAEA;EACE,0BAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.clickable-text {\n  cursor: pointer !important;\n}\n",".clickable-text {\n  cursor: pointer !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
